/**
 * @desc 获取OSS文件的URL
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** filename */
  filename: string;
}

export function request(params: Params): Promise<defs.StandardReturn<string>> {
  return defHttp.get({
    url: '/oss/url',

    params,
  });
}

export function mock(params: Params): Promise<defs.StandardReturn<string>> {
  return defHttp.get({
    url: '/mock/oss/url',

    params,
  });
}
